import useUser from './useUser';
import useAccountsAsync from './useAccountsAsync';

export default function useUserFullName(userId: string): string {
  const user = useUser(userId);
  const { data: accounts } = useAccountsAsync();

  if (user) {
    return [user.given_name, user.family_name].filter(Boolean).join(' ') || userId;
  }

  const account = accounts && accounts.find((a) => a.id === userId);

  if (account) {
    return account.organization_name || userId;
  }

  return userId;
}
